import { MedicalProfession } from "@domain/localization/country";
import { useMedicalProfession } from "@ui/pages/referential/use-medical-professions";
import { useMemo } from "react";

export interface MedicalProfessionOption {
	label: string;
	value: MedicalProfession | string;
}

interface useMedicalProfessionOptionsProps {
	medicalProfessions: MedicalProfession[];
}

interface useMedicalProfessionOptionsHook {
	medicalProfessionOptions: MedicalProfessionOption[];
}

export function useMedicalProfessionOptions({
	medicalProfessions,
}: useMedicalProfessionOptionsProps): useMedicalProfessionOptionsHook {
	const { formatMedicalProfession } = useMedicalProfession();
	const medicalProfessionOptions = useMemo(
		() =>
			medicalProfessions.map(profession => ({
				value: profession,
				label: formatMedicalProfession(profession),
			})),
		[formatMedicalProfession, medicalProfessions],
	);

	return { medicalProfessionOptions };
}
